// Library imports
import React, { useEffect, useState } from 'react';
// Component imports
import PlayerData from './PlayerData';
import TeamRoster from './TeamRoster';
import PropInsights from './PropInsights';
import { InnerContent } from '../styles';

const Rosters = ({ game, sport, demo, hasPropsAccess = false }) => {
    const [view, setView] = useState('roster');
    const [player, setPlayer] = useState(null);
    const [selectedProp, setSelectedProp] = useState('');
    const [playerWithProps, setPlayerWithProps] = useState(null);

    useEffect(() => {
        if (view === 'roster') {
            setPlayer(null);
            setPlayerWithProps(null);
            setSelectedProp('');
        }
        if (view === 'player-data') {
            setSelectedProp('');
            setPlayerWithProps(null);
        }
    }, [view]);

    if (!demo && !hasPropsAccess) {
        return (
            <InnerContent fluid>
                <div
                    style={{
                        margin: '0.55rem',
                        padding: '1.05rem 1rem',
                        border: '1px dashed rgba(250,204,21,0.45)',
                        borderRadius: 12,
                        background: 'linear-gradient(160deg, rgba(113,63,18,0.18) 0%, rgba(15,23,42,0.58) 100%)',
                        color: '#fef3c7',
                        textAlign: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <span
                        style={{
                            width: 30,
                            height: 30,
                            borderRadius: 999,
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: 8,
                            border: '1px solid rgba(250,204,21,0.5)',
                            background: 'rgba(250,204,21,0.14)'
                        }}
                    >
                        <i className="fas fa-lock" style={{ fontSize: '0.82rem', color: '#fef3c7' }} />
                    </span>
                    <p style={{ margin: 0, fontSize: '0.84rem', fontWeight: 800, color: '#fffbeb' }}>Roster insights locked</p>
                    <p style={{ margin: '0.25rem 0 0', fontSize: '0.74rem', color: '#fcd34d' }}>
                        Add the Props add-on to view roster and props insights.
                    </p>
                </div>
            </InnerContent>
        );
    }

    if (view === 'roster') {
        return <TeamRoster game={game} sport={sport} setView={setView} setPlayer={setPlayer} demo={demo} />;
    }
    if (view === 'player-data') {
        return <PlayerData player={player} setView={setView} setSelectedProp={setSelectedProp} setPlayerWithProps={setPlayerWithProps} demo={demo} />;
    }
    if (view === 'prop-insights') {
        return <PropInsights playerData={playerWithProps} selectedProp={selectedProp} setView={setView} game={game} />;
    }
};

export default Rosters;
